import TransactionEditForm from '../Components/TransactionEditForm';

function Edit() {
  return (
    <div>
      <h1>Edit transaction</h1>
      <TransactionEditForm />
    </div>
  );
}

export default Edit;